// Define supported journals for type-checking
export const supportedJournals = ['bmj'] as const;

// Created a function to map the journal.slug to one of the valid types
export const mapJournalToVariant = (
  slug: string,
): (typeof supportedJournals)[number] | undefined => {
  return supportedJournals.includes(slug as (typeof supportedJournals)[number])
    ? (slug as (typeof supportedJournals)[number])
    : undefined;
};
